import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import history from './history'
import Header from './components/Header'
import Grad21 from './components/Grad21'
import Footer from './components/Footer'

const App = () => (
  <BrowserRouter history={history} basename="/event/lp">
    <div className="App">
      <Header />
      <Switch>
        <Route exact path={`${process.env.PUBLIC_URL}/21`} component={Grad21} />      
      </Switch>
      <Footer />
    </div>
  </BrowserRouter>
)
export default App